// NOTE: SecondRow (sticky header on scroll) deaktiviert - Farb-Kontrast nicht zuverlässig mit allen Kunden-Themes
'use client';

import { useLocale } from 'next-intl';

import { useIsCustomDomain } from '../../context/CustomDomainContext';
import { resolveRoute } from '../../util/routeResolver';
import { LanguageSelect } from '../LanguageSelect';
import { Link } from '../Link';
import { S } from './Header.styles';
import type { HeaderClientProps } from './Header.types';

const FALLBACK_LOGO_URL = 'https://d3nnb1hxumbr0v.cloudfront.net/images/logos2024Relaunch/favicons/favicon-192.png';

export const HeaderClient = ({
  customerCompanyNumber,
  companyId,
  companyName,
  logoPicture,
  loading,
  ...otherProps
}: HeaderClientProps) => {
  const isCustom = useIsCustomDomain();
  const locale = useLocale();
  const logoPosition = logoPicture?.position?.horizontal || 'left';
  const logoHref =
    logoPicture?.clickUrl || resolveRoute('jobList', { locale, companyId: isCustom ? undefined : companyId });

  const logoElement = !loading ? (
    <Link href={logoHref} data-guide-id="header-logo-link">
      <S.Logo
        src={logoPicture?.url || FALLBACK_LOGO_URL}
        alt={companyName || 'Logo'}
        sizes="220px"
        data-guide-id="header-logo-image"
      />
    </Link>
  ) : null;

  return (
    <S.Container data-guide-id="header-container" {...otherProps}>
      <S.Row css={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center' }}>
        <div css={{ justifySelf: 'start' }}>{logoPosition === 'left' && logoElement}</div>
        <div css={{ justifySelf: 'center' }}>{logoPosition === 'center' && logoElement}</div>
        <div css={{ justifySelf: 'end', display: 'flex', alignItems: 'center', gap: 16 }}>
          <LanguageSelect data-guide-id="header-language-select" />
          {logoPosition === 'right' && logoElement}
        </div>
      </S.Row>
    </S.Container>
  );
};
